import { getAccessToken } from '@platform/core/src/utils/tokenStorage';
import { getLegalComplianceStatus } from '@platform/core/src/services/legalApi';
import { getMyFitnessProfile } from './profileApi';

let startupPromise = null;

/**
 * Starts the onboarding checks immediately if a token exists.
 * This should be called outside of any React component.
 */
export const preloadStartupData = () => {
    // Prevent double invocation if promise already exists
    if (startupPromise) {
        return;
    }

    const token = getAccessToken();
    if (!token) {
        startupPromise = Promise.resolve(null);
        return;
    }

    startupPromise = Promise.allSettled([
        getLegalComplianceStatus('workout_smart'),
        getMyFitnessProfile()
    ]).then(([legalResult, profileResult]) => {
        const legalData = legalResult.status === 'fulfilled' ? legalResult.value : null;
        const profileData = profileResult.status === 'fulfilled' ? profileResult.value : null;
        return { legalData, profileData };
    });
};

/**
 * Returns the promise initiated by preloadStartupData.
 * The Strategy function will await this.
 */
export const getStartupData = () => {
    if (!startupPromise) {
        return Promise.resolve(null);
    }
    return startupPromise;
};

/**
 * Clear cache on logout
 */
export const clearStartupCache = () => {
    startupPromise = null;
};